/**
 * @ngdoc service
 * @module evtviewer.namedEntity
 * @name evtviewer.namedEntity.evtNamedEntity
 * @description
 * # evtNamedEntity
 * This provider expands the scope of the
 * {@link evtviewer.namedEntity.directive:evtNamedEntity evtNamedEntity} directive
 * and stores its reference untill the directive remains instantiated.
 *
 * @requires $timeout
 * @requires evtviewer.core.config
 * @requires evtviewer.dataHandler.parsedData
 * @requires evtviewer.dataHandler.evtNamedEntitiesParser
 * @requires evtviewer.interface.evtInterface
 * @requires evtviewer.namedEntity.evtNamedEntityRef
 * @requires evtviewer.UItools.evtPinnedElements
**/
angular.module('evtviewer.namedEntity')

.provider('evtNamedEntity', function() {

    var defaults = this.defaults;

    this.setDefaults = function(_defaults) {
        defaults = _defaults;
    };

    /**
     * @ngdoc object
     * @module evtviewer.namedEntity
     * @name evtviewer.namedEntity.controller:NamedEntityCtrl
     * @description
     * # NamedEntityCtrl
     * <p>This is controller for the {@link evtviewer.namedEntity.directive:evtNamedEntity evtNamedEntity} directive. </p>
     * <p>It is not actually implemented separately but its methods are defined in the
     * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider
     * where the scope of the directive is extended with all the necessary properties and methods
     * according to specific values of initial scope properties.</p>
     **/
    this.$get = ['$timeout', 'config', 'parsedData', 'evtNamedEntitiesParser', 'evtInterface', 'evtNamedEntityRef', 'evtPinnedElements', 'evtDialog', 'evtList',
        function($timeout, config, parsedData, evtNamedEntitiesParser, evtInterface, evtNamedEntityRef, evtPinnedElements, evtDialog, evtList) {
            var namedEntity    = {},
                collection = {},
                list       = [],
                idx        = 0;
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#getElementContent
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Get the main output of scope named entity.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             */
            var getElementContent = function() {
                var vm = this;
                var namedEntity = parsedData.getNamedEntity(vm.entityId);
                return namedEntity.output;
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#toggle
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Open/close the details panel of named entity element.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             */
            var toggle = function() {
                var vm = this;
                if (vm.location !== 'mainText') {
                    vm.toggleSubContent(vm._firstSubContentOpened);

                    vm.opened = !vm.opened;
                    vm.toggleState();
                }
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#toggleOccurrences
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Open/close the "Occurrences" tab of named entity details panel.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             */
            var toggleOccurrences = function() {
                var vm = this;
                if (!vm.occurrences) {
                    if (vm.entity && vm.entity._multiple) {
                        // For multiple entities, get occurrences for the currently selected reference
                        var selectedEntity = vm.entity._entities[vm.activeReferenceTab];
                        if (selectedEntity && !selectedEntity.occurrences) {
                            selectedEntity.occurrences = namedEntity.getOccurrences(selectedEntity.id || selectedEntity._id);
                        }
                    } else {
                        // For single entities, use the original logic
                        vm.occurrences = namedEntity.getOccurrences(vm.entityId);
                    }
                }
                vm.occurrencesOpened = !vm.occurrencesOpened;
                vm.toggleSection('occurrencesOpened');
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#toggleMoreInfo
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Open/close the "More Info" tab of named entity details panel.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             */
            var toggleMoreInfo = function() {
                var vm = this;
                vm.moreInfoOpened = !vm.moreInfoOpened;
                vm.toggleSection('moreInfoOpened');
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#goToOccurrence
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Navigate to given document and page of given occurrence.</p>
             * <p>Highlight the occurrence in arrival page.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             * @param {Object} occurrence Object representing the occurence we want to navigate to.
             * It contains all the information about document and page to which navigate.
             */
            var goToOccurrence = function(occurrence) {
                var vm = this;
                evtInterface.updateState('currentPage', occurrence.pageId);
                evtInterface.updateState('currentDoc', occurrence.docId);
                evtInterface.updateUrl();
                if (evtInterface.getState('secondaryContent') === 'entitiesList') {
                    evtInterface.updateState('secondaryContent', '');
                }
                $timeout(function() {
                    evtNamedEntityRef.highlightByEntityId(vm.entityId);
                }, 500);
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#toggleSubContent
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Open/close a given tab of named entity details panel.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             * @param {string} subContentName Name of tab to toggle
             */
            var toggleSubContent = function(subContentName) {
                var vm = this;
                if (subContentName === 'occurrences') {
                    if (vm.entity && vm.entity._multiple) {
                        // For multiple entities, get occurrences for the currently selected reference
                        var selectedEntity = vm.entity._entities[vm.activeReferenceTab];
                        // console.log('toggleSubContent - occurrences tab, selectedEntity:', selectedEntity);
                        if (selectedEntity && !selectedEntity.occurrences) {
                            var entityId = selectedEntity.id || selectedEntity._id;
                            // console.log('Getting occurrences for entity ID:', entityId);
                            selectedEntity.occurrences = namedEntity.getOccurrences(entityId);
                            // console.log('Occurrences loaded:', selectedEntity.occurrences);
                        }
                    } else if (!vm.occurrences) {
                        // For single entities, use the original logic
                        vm.occurrences = namedEntity.getOccurrences(vm.entityId);
                    }
                }
                if (vm._subContentOpened !== subContentName) {
                    vm._subContentOpened = subContentName;
                } else {
                    vm._subContentOpened = '';
                }

                vm.toggleSubContentClass();
            };

            //Pin Tool Functions
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#isPinAvailable
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Check whether the "Pin" tool is available or not.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             * @returns {boolean} whether the "Pin" tool is available or not
             */
            var isPinAvailable = function(){
                return config.toolPinAppEntries;
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#isPinned
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Check whether the named entity is "Pinned" or not.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             * @returns {boolean} whether the named entity is "Pinned" or not
             */
            var isPinned = function(){
                var vm = this;
                return evtPinnedElements.isPinned(vm.entityId);
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#getPinnedState
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Get "pinned" icon state.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             * @returns {string} name of class to give to "Pin" button:
             * "pin-on" if the named entity is "Pinned", "pin-off" othewise
             */
            var getPinnedState = function() {
                var vm = this;
                return vm.isPinned() ? 'pin-on' : 'pin-off';
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#getPinnedState
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Toggle "pinned" state.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             */
            var togglePin = function(){
                var vm = this;
                if (vm.isPinned()) {
                    evtPinnedElements.removeElement({id: vm.entityId, type: 'namedEntity_'+vm.entityType });
                } else {
                    evtPinnedElements.addElement({ id: vm.entityId, type: 'namedEntity_'+vm.entityType });
                    var pinnedElements = evtPinnedElements.getPinned();
                    if (pinnedElements && pinnedElements.length === 1) {
                    evtInterface.updateState('isPinnedAppBoardOpened', true);
                    }
                }
            };
            var openEntity = function() {
                var vm = this;
                //console.log('openEntity called with entityId:', vm.entityId, 'activeReferenceTab:', vm.activeReferenceTab);
                
                // var secondaryContent = config.globalMenuAvailable ? 'toc' : 'entitiesList';
                var secondaryContent = 'toc';
                evtInterface.updateState('secondaryContent', secondaryContent);
                evtDialog.openByType(secondaryContent);
                
                // Handle multiple references by using the selected entity ID for navigation
                var entityIdForNavigation = vm.entityId;
                if (vm.entityId && vm.entityId.includes(' ')) {
                    // Multiple references - use the selected one for navigation
                    var entityIds = vm.entityId.split(' ');
                    var selectedIndex = vm.activeReferenceTab || 0;
                    entityIdForNavigation = entityIds[selectedIndex] || entityIds[0];
                    // console.log('Multiple references detected. Entity IDs:', entityIds, 'Selected index:', selectedIndex, 'Navigation ID:', entityIdForNavigation);
                }
                
                // console.log('Getting named entities for ID:', entityIdForNavigation);
                var namedEntities = parsedData.getNamedEntities();
                // console.log('Named entities available:', Object.keys(namedEntities));
                var entity = namedEntities[entityIdForNavigation];
                // console.log('Found entity:', entity);
                
                if (entity && entity.collectionId) {
                    var list = entity.collectionId;
                    // console.log('List collection ID:', list);
                    
                    // if (config.globalMenuAvailable) {
                        evtInterface.updateProperty('tabsContainerOpenedContent', 'entitiesLists');
                        evtInterface.updateProperty('tabsContainerOpenedTab', list);                
                    // } else {
                    //     evtInterface.updateProperty('tabsContainerOpenedContent', list);
                    // }
                    evtInterface.updateState('currentNamedEntity', entityIdForNavigation);
                    setTimeout(function() {
                        evtList.scrollToElemById(list, entityIdForNavigation);
                    }, 1000);
                } else {
                    console.error('Entity not found or missing collectionId:', entityIdForNavigation);
                }
            }

            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#openExternalLink
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Open the external sameAs link in a new tab.</p>
             */
            var openExternalLink = function() {
                var vm = this;
                var sameAsUrl = null;

                // Check for single entity sameAs
                if (vm.entity && vm.entity.sameAs) {
                    sameAsUrl = vm.entity.sameAs;
                }
                // Check for multiple entities - use the selected one
                else if (vm.entity && vm.entity._multiple && vm.entity._entities) {
                    var selectedIndex = vm.activeReferenceTab || 0;
                    var selectedEntity = vm.entity._entities[selectedIndex];
                    if (selectedEntity && selectedEntity.sameAs) {
                        sameAsUrl = selectedEntity.sameAs;
                    }
                }

                if (sameAsUrl) {
                    window.open(sameAsUrl, '_blank');
                }
            }

            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.controller:NamedEntityCtrl#isCurrentPageDoc
             * @methodOf evtviewer.namedEntity.controller:NamedEntityCtrl
             *
             * @description
             * <p>Check whether a given occurrence is pointing to the current Doc/Page pair.</p>
             * <p>This method is defined and attached to controller scope in the
             * {@link evtviewer.namedEntity.evtNamedEntity evtNamedEntity} provider file.</p>
             * @param {Object} occurrence Object representing the occurence we want to navigate to.
             * It contains all the information about document and page to which navigate.
             */
            var isCurrentPageDoc = function(occurrence) {
                var currentDoc = evtInterface.getState('currentDoc'),
                    currentPage = evtInterface.getState('currentPage');
                return (currentDoc === occurrence.docId && currentPage === occurrence.pageId);
            };
            //
            // NamedEntity builder
            //
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.evtNamedEntity#build
             * @methodOf evtviewer.namedEntity.evtNamedEntity
             *
             * @description
             * <p>This method will extend the scope of {@link evtviewer.namedEntity.directive:evtNamedEntity evtNamedEntity} directive
             * according to selected configurations and parsed data.</p>
             *
             * @param {string} id Named Entity unique identifier
             * @param {Object} scope initial scope of the directive:
                <pre>
                    var scope: {
                        entityId   : '@',
                        entityType : '@',
                        location   : '@'
                    };
                </pre>
            *
            * @returns {Object} extended scope:
                <pre>
                    var scopeHelper = {
                        // expansion
                        uid,
                        entityId,
                        entityType,
                        entityTypeIcon,
                        location,

                        entity,
                        occurrences,

                        opened,
                        moreInfoOpened,
                        occurrencesOpened,
                        noMoreInfo,
                        _firstSubContentOpened,
                        _subContentOpened,
                        over,
                        tabs,

                        defaults,

                        // functions
                        getElementContent,
                        toggle,
                        toggleMoreInfo,
                        toggleOccurrences,
                        goToOccurrence,
                        toggleSubContent,
                        isCurrentPageDoc,

                        // pin tool
                        isPinAvailable,
                        isPinned,
                        getPinnedState,
                        togglePin
                    };
                </pre>
            */
            namedEntity.build = function(id, scope) {
                var currentId  = idx++,
                    entityId   = id || undefined,
                    entityType = scope.entityType || parsedData.getNamedEntityType(entityId) || 'generic',
                    location = scope.location || 'list',
                    attributes = '';

                var scopeHelper = {};

                if (typeof(collection[currentId]) !== 'undefined') {
                    return;
                }

                var namedEntity = parsedData.getNamedEntity(entityId),
                    moreInfoAvailable = true,
                    entityTypeIcon = parsedData.getNamedEntityTypeIcon(entityType);

                moreInfoAvailable = namedEntity !== undefined && namedEntity.notes !== undefined && namedEntity.notes.length > 0;
                switch (entityType) {
                    case 'place':
                    case 'placeName':
                    case 'person':
                    case 'pers':
                    case 'persName':
                        break;
                    case 'org':
                    case 'orgName':
                        moreInfoAvailable = moreInfoAvailable || (namedEntity !== undefined && namedEntity.desc !== undefined);
                        break;
                    default:
                        moreInfoAvailable = moreInfoAvailable || (namedEntity !== undefined && namedEntity.details !== undefined);
                        break;
                }

                // Handle entity occurrences
                var occurrences;
                if (namedEntity && namedEntity.occurrences) {
                    occurrences = namedEntity.occurrences;
                } else {
                    // Ask interface to calculate occurrences for entity
                    //occurrences = [{ pageId: "fol_214v", pageLabel: "214v", docId: "CI_118", docLabel: "CI (118)" }];
                }
                var tabs = {
                    _indexes : []
                };
                if (defaults.allowedTabs.indexOf('moreInfo') >= 0) {
                    tabs._indexes.push('moreInfo');
                    tabs.moreInfo = { label: 'NAMED_ENTITIES.MORE_INFO' };
                }

                if (entityType !== 'relation') {
                    tabs._indexes.push('occurrences');
                    tabs.occurrences = { label: 'NAMED_ENTITIES.OCCURRENCES' };
                }

                var center = {
                    zoom: 11
                };
                var mainMarker = {
                    focus: true,
                    draggable: false
                };
                var lfDefaults = {
                    tileLayer: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                    tileLayerOptions: {
                        opacity: 0.9,
                        detectRetina: true,
                        reuseTiles: true,
                    }
                };
                // POLO-TODO: implementare parsing di coordinate e controllo.
                if (defaults.allowedTabs.indexOf('map') >= 0 && (entityType === 'place' || entityType === 'placeName') && namedEntity.map) {
                    tabs._indexes.push('map');
                    tabs.map = { label: 'NAMED_ENTITIES.MAP' };
                    var lat = parseFloat(namedEntity.map.lat);
                    var lng = parseFloat(namedEntity.map.lng);
                    center.lat = lat;
                    center.lng = lng;
                    mainMarker.lat = lat;
                    mainMarker.lng = lng;
                    // Add popup message with place name and Google Maps link
                    var placeName = namedEntity.label || entityId;
                    var googleMapsUrl = 'https://www.google.com/maps?q=' + lat + ',' + lng;
                    mainMarker.message = '<strong>' + placeName + '</strong><br>' +
                        '<a href="' + googleMapsUrl + '" target="_blank" style="color: #1a73e8;">Open in Google Maps</a>';
                    mainMarker.getMessageScope = function() { return $rootScope.$new(); };
                }
                if (defaults.allowedTabs.indexOf('xmlSource') >= 0) {
                    tabs._indexes.push('xmlSource');
                    tabs.xmlSource = { label: 'NAMED_ENTITIES.XML' };
                }

                var firstSubContentOpened = tabs && tabs._indexes && tabs._indexes.length > 0 ? tabs._indexes[0] : '';
                scopeHelper = {
                    // expansion
                    uid           : currentId,
                    entityId      : entityId,
                    entityType    : entityType,
                    entityTypeIcon : entityTypeIcon,
                    location      : location,

                    entity        : namedEntity ? namedEntity : {},
                    occurrences   : occurrences,

                    opened         : false,
                    moreInfoOpened : moreInfoAvailable,
                    occurrencesOpened : false,
                    noMoreInfo    :  !moreInfoAvailable,
                    _firstSubContentOpened : firstSubContentOpened,
                    _subContentOpened : '',
                    over              : false,
                    tabs              : tabs,

                    // Pagination for occurrences
                    occurrencesLimit : 10,
                    occurrencesStart : 0,

                    defaults      : angular.copy(defaults),

                    // functions
                    getElementContent : getElementContent,
                    toggle            : toggle,
                    toggleMoreInfo    : toggleMoreInfo,
                    toggleOccurrences : toggleOccurrences,
                    goToOccurrence    : goToOccurrence,
                    toggleSubContent  : toggleSubContent,
                    isCurrentPageDoc  : isCurrentPageDoc,
                    nextOccurrences   : function(totalLength) {
                        if (this.occurrencesStart + this.occurrencesLimit < totalLength) {
                            this.occurrencesStart += this.occurrencesLimit;
                        }
                    },
                    prevOccurrences   : function() {
                        if (this.occurrencesStart > 0) {
                            this.occurrencesStart -= this.occurrencesLimit;
                        }
                    },
                    

                    


                    // pin tool
                    isPinAvailable : isPinAvailable,
                    isPinned: isPinned,
                    getPinnedState: getPinnedState,
                    togglePin: togglePin,
                    openEntity: openEntity,
                    openExternalLink: openExternalLink,

                    // Multiple reference tabs functionality
                    activeReferenceTab : 0,
                    setActiveReferenceTab : function(index) {
                        this.activeReferenceTab = index;
                    },
                    
                    loadOccurrencesForEntity : function(entityIndex) {
                        var vm = this;
                        if (vm.entity && vm.entity._multiple && vm.entity._entities[entityIndex]) {
                            var entityId = vm.entity._entities[entityIndex].id || vm.entity._entities[entityIndex]._id;
                            if (entityId) {
                                // Use the same method as getOccurrences for consistency
                                vm.entity._entities[entityIndex].occurrences = namedEntity.getOccurrences(entityId);
                            }
                        }
                    },
                    
                    lfCenter: center,
                    lfDefaults: lfDefaults,
                    lfMarkers: { mainMarker : mainMarker }
                };

                collection[currentId] = angular.extend(scope.vm, scopeHelper);
                list.push({
                    id: currentId,
                    entityId: entityId
                });

                return collection[currentId];
            };


            //
            // Service function
            //
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.evtNamedEntity#getOccurrences
             * @methodOf evtviewer.namedEntity.evtNamedEntity
             *
             * @description
             * <p>Get the list of occurrences of a given named entity.</p>
             * <p>Data are parsed from originale XML source document, by using
             * {@link evtviewer.dataHandler.evtNamedEntitiesParser#parseEntitiesOccurrences parseEntitiesOccurrences}
             * method</p>
             *
             * @param {string} refId Named entity unique identifier
             * @returns {array} List of occurrences of given named entity
             */
            namedEntity.getOccurrences = function(refId) {
                var documentsCollection = parsedData.getDocuments(),
                    documentsIndexes = documentsCollection._indexes || [],
                    totOccurrences = [];
                for (var i = 0; i < documentsIndexes.length; i++) {
                    var currentDoc = documentsCollection[documentsIndexes[i]],
                        docPages = evtNamedEntitiesParser.parseEntitiesOccurrences(currentDoc, refId);
                    totOccurrences = totOccurrences.concat(docPages);
                }
                return totOccurrences;
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.evtNamedEntity#getById
             * @methodOf evtviewer.namedEntity.evtNamedEntity
             *
             * @description
             * Get the reference of the instance of a particular <code>&lt;evt-named-entity&gt;</code>.
             *
             * @param {string} entityId Id of <code>&lt;evt-named-entity&gt;</code> to retrieve
             *
             * @returns {Object} Reference of the instance of <code>&lt;evt-named-entity&gt;</code> with given id
             */
            namedEntity.getById = function(entityId) {
                var foundNamedEntity;
                angular.forEach(collection, function(currentNamedEntity) {
                    if (currentNamedEntity.entityId === entityId) {
                        foundNamedEntity = currentNamedEntity;
                    }
                });
                return foundNamedEntity;
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.evtNamedEntity#getList
             * @methodOf evtviewer.namedEntity.evtNamedEntity
             *
             * @description
             * Get the list of all the instance of <code>&lt;evt-named-entity&gt;</code>.
             *
             * @returns {array} array of ids of all the instance of <code>&lt;evt-named-entity&gt;</code>.
             */
            namedEntity.getList = function() {
                return list;
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.evtNamedEntity#getPinned
             * @methodOf evtviewer.namedEntity.evtNamedEntity
             *
             * @description
             * Get the list of all the ids of named entity that are "pinned".
             * It uses the {@link evtviewer.UITools.evtPinnedElements#getPinnedByType getPinnedByType} method
             * defined in {@link evtviewer.UITools.evtPinnedElements evtPinnedElements} service.
             *
             * @returns {array} array of ids of named entity that are "pinned".
             */
            namedEntity.getPinned = function() {
                return evtPinnedElements.getPinnedByType('namedEntity');
            };
            /**
             * @ngdoc method
             * @name evtviewer.namedEntity.evtNamedEntity#destroy
             * @methodOf evtviewer.namedEntity.evtNamedEntity
             *
             * @description
             * Delete the reference of the instance of a particular <code>&lt;evt-named-entity&gt;</code>
             *
             * @param {string} tempId id of <code>&lt;evt-named-entity&gt;</code> to destroy
             */
            namedEntity.destroy = function(tempId) {
                delete collection[tempId];
            };

            return namedEntity;
        }];

});
